import { useState } from 'react'
import { canAccessWebLocalStorage } from '@mote/helpers'
import { ONBOARDING_LOOPS_STORAGE_KEY } from '@mote/helpers/constants'

export type UseLoopsOnboardingControl = {
  seen: boolean
  setSeen: () => void
  show: boolean
}

export function useLoopsOnboardingControl(): UseLoopsOnboardingControl {
  const [seen, setSeen] = useState<boolean>(
    () =>
      !canAccessWebLocalStorage() ||
      Boolean(window.localStorage.getItem(ONBOARDING_LOOPS_STORAGE_KEY))
  )
  const [onbardingShown, setOnobardingShown] = useState<boolean>(true)

  function setSeenLoopsOnboarding(): void {
    if (canAccessWebLocalStorage()) {
      window.localStorage.setItem(ONBOARDING_LOOPS_STORAGE_KEY, 'true')
    }
    setOnobardingShown(false)
    setSeen(true)
  }

  return {
    seen: seen,
    setSeen: setSeenLoopsOnboarding,
    show: onbardingShown
  }
}
